/* Masterclass CRO 6.1 : éléments communs, sans changer le design du thème. */
(function(){
  'use strict';
  /* Barre d'annonce : trois messages en rotation, une seule ligne.
     Le point relais n'est offert que la ou il coute moins que la limite de
     4,90 € : France, Belgique, Luxembourg. Ailleurs il existe mais reste
     payant, alors on annonce son tarif plutot qu'une gratuite qui ne viendra
     pas ; sans relais du tout (Suisse, Reunion, Guyane) on n'annonce qu'un
     delai. Meme table que SC_RELAIS dans shopify-runtime.js et que
     snippets/port-promesse.liquid : les trois doivent bouger ensemble. */
  var RELAIS={FR:'2,90 €',BE:'4,90 €',LU:'4,90 €',NL:'5,50 €',DE:'6,60 €',ES:'6,50 €',PT:'6,50 €',PL:'7,10 €',IT:'7,30 €'};
  var PAYS_PORT_OFFERT=['FR','BE','LU'];
  var pays=String((window.Shopify||{}).country||'FR').toUpperCase();
  var promesse=PAYS_PORT_OFFERT.indexOf(pays)>=0
    ?'Livraison offerte dès 30 € en point relais'
    :(RELAIS[pays]?'Point relais à '+RELAIS[pays]:'Expédié de Nice sous 48 h ouvrées');
  /* Fenetre et phrases de l'operation : window.SC_OPERATION, pose par
     snippets/offre-cadeau.liquid. Meme source que scOffreEnCours() dans
     shopify-runtime.js, donc une seule date a changer pour prolonger. Le
     repli ne sert que si le snippet n'a pas ete rendu. */
  var OP=window.SC_OPERATION||{debut:20261019,fin:20261031,
    longue:'Du 19 au 31 octobre : un siwak et son porte-siwak offerts à chaque commande',
    courte:'Un siwak offert à chaque commande, jusqu’au 31 octobre'};
  var d=new Date(),jour=d.getFullYear()*10000+(d.getMonth()+1)*100+d.getDate();
  /* Deux versions : le bandeau ne defile pas et coupe en silence ce qui
     depasse. Mesure sur 375 px, la phrase longue fait 458 px. */
  var offre=(jour>=OP.debut&&jour<=OP.fin)
    ?[(window.innerWidth>=700)?OP.longue:OP.courte]
    :[];
  var MSG=offre.concat([promesse,'60 jours pour essayer. Pas convaincu ? On vous rembourse.','4,8/5 sur Trustpilot · 51 avis · 10 000 clients']);
  document.querySelectorAll('[data-announce-rot]').forEach(function(a){
    var i=0;a.textContent=MSG[0];
    /* Pendant l'operation, le bandeau ne tourne pas : une offre qui ne
       s'affiche qu'un quart du temps n'est pas une offre annoncee. Il
       reprend sa rotation tout seul au lendemain de la fin de l'operation,
       quand `offre` redevient vide. */
    if(offre.length)return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    setInterval(function(){a.style.opacity='0';setTimeout(function(){i=(i+1)%MSG.length;a.textContent=MSG[i];a.style.opacity='1';},250);},5000);
  });

  /* Pop-up Klaviyo : un clic sur le voile sombre le fermait, y compris le clic
     parti de travers qu'on n'avait pas voulu. On intercepte le clic avant que
     Klaviyo ne le voie, mais seulement s'il tombe sur le voile : la croix, le
     champ e-mail et le bouton vivent dans le pop-up, donc ils passent tous.
     Phase de capture obligatoire, sinon le gestionnaire de Klaviyo a deja agi.
     data-testid est le seul repere stable : la classe kl-private-reset-css-xxxxxx
     change a chaque publication du formulaire. */
  function voileDuPopup(popup){
    var e=popup;
    while(e&&e!==document.body){
      if(getComputedStyle(e).position==='fixed')return e;
      e=e.parentElement;
    }
    return null;
  }
  function gardePopup(ev){
    var popup=document.querySelector('[data-testid="POPUP"]');
    if(!popup||popup.contains(ev.target))return;
    var voile=voileDuPopup(popup);
    if(!voile||!voile.contains(ev.target))return;
    ev.stopPropagation();
    /* Pas de preventDefault sur touchstart : l'ecouteur y est passif par
       defaut, l'appel serait ignore et bruyant dans la console. */
    if(ev.cancelable&&ev.type!=='touchstart')ev.preventDefault();
  }
  ['pointerdown','mousedown','touchstart','click'].forEach(function(t){
    document.addEventListener(t,gardePopup,true);
  });

  /* Newsletter du pied de page : API client publique de Klaviyo (liste du pop-up).
     Révision 2025-10-15 obligatoire : avec 2024-10-15, le champ « subscriptions » est refusé (erreur 400). */
  var KLAVIYO_PUBLIC='VCsBZb',KLAVIYO_LISTE='TTMk2U';
  document.querySelectorAll('[data-cx-news]').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var champ=form.querySelector('input[type=email]'),retour=form.parentNode.querySelector('.cx-news__retour'),bouton=form.querySelector('button');
      var email=(champ.value||'').trim();
      var dire=function(t){if(retour){retour.hidden=false;retour.textContent=t;}};
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){dire('Vérifiez votre adresse e-mail.');champ.focus();return;}
      bouton.disabled=true;
      fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(KLAVIYO_PUBLIC),{
        method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':'2025-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Pied de page siwaksmile.com',profile:{data:{type:'profile',attributes:{email:email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:KLAVIYO_LISTE}}}}})
      }).then(function(r){
        if(r.status===202||r.ok){champ.value='';dire('C’est noté. Le guide arrive dans votre boîte mail.');}
        else{throw new Error(String(r.status));}
      }).catch(function(){dire('Un souci est survenu. Réessayez dans un instant.');}).finally(function(){bouton.disabled=false;});
    });
  });

  /* WhatsApp : « Une question ? » au premier affichage puis l'icône seule ;
     masqué quand le bloc d'achat ou le panier est à l'écran. */
  var wa=document.querySelector('.wa-float');
  if(wa){
    if(!wa.querySelector('.wa-float__txt')){var s=document.createElement('span');s.className='wa-float__txt';s.textContent='Une question ?';wa.appendChild(s);}
    setTimeout(function(){wa.classList.add('is-icone');},6000);
    var cibles=document.querySelectorAll('.pdp__buy');
    var visibles=0;
    if(cibles.length)wa.classList.add('is-masque');
    var etat=function(){var panier=!!document.querySelector('.sc.is-open');wa.classList.toggle('is-masque',visibles>0||panier);};
    if('IntersectionObserver' in window&&cibles.length){
      var obs=new IntersectionObserver(function(entrees){entrees.forEach(function(en){visibles+=en.isIntersecting?1:-1;if(visibles<0)visibles=0;});etat();},{threshold:0.05});
      cibles.forEach(function(c){obs.observe(c);});
    }
    setInterval(etat,700);
  }
})();
/* Masterclass 6.1 : en-tête compact au défilement. */
(function(){
  var h=document.querySelector('.header');if(!h)return;
  var c=false;var maj=function(){var v=window.scrollY>80;if(v!==c){c=v;h.classList.toggle('is-compact',v);}};
  window.addEventListener('scroll',maj,{passive:true});maj();
})();
